const init = () => {
    document.querySelectorAll('.brandspace__nav li').forEach((content) => {
        content.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const anchorChild = content.querySelector('a');
            if (undefined === anchorChild || null === anchorChild) {
                return;
            }
            const targetId = anchorChild.dataset.targetId;
            if (!targetId) {
                return;
            }
            const target = document.getElementById(targetId);
            if (!target) {
                return;
            }
            target.scrollIntoView({ behavior: 'smooth' });
        });
    });
};
export default () => {
    init();
};
